import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Container } from 'reactstrap';
// import logo from '../../images/logo-full.png';

import { Layout, PageTitle, FormGroup, Input, Radio, PillButton, PreLoader, Modal } from '../../components';
import useCreateCustomer from '../../providers/Customer/useCreateCustomer';
import { routes } from '../../constants';

function Register() {
  const [{ isOpen, showMessage }, setModalState] = useState({ isOpen: false });
  const {
    form: { text, email, date, radio },
    _v,
    loading,
    handleSubmit,
    messageOpts,
  } = useCreateCustomer({ setModalState });

  const closeModal = () => {
    setModalState({ isOpen: false });
  };

  return (
    <Layout>
      <Modal isOpen={isOpen} onBackgroundClick={closeModal} onEscapeKeydown={closeModal}>
        <div>
          <h3>Thanks for Choosing us</h3>
          <p>
            {showMessage === messageOpts.new
              ? 'Your details have been saved and we will reach out to you in the next 24hrs.'
              : ''}
            {showMessage === messageOpts.dup
              ? "Seems you are already registered with us. Can't wait to work with you, We'll get back to you shortly"
              : ''}
          </p>
          <button href="/#" onClick={closeModal}>
            Close
          </button>
        </div>
      </Modal>
      <PageTitle pageName="login-page" title="Register" />
      <div className="contact login-page-content pb-5 mb-5">
        <Container>
          <div className="row justify-content-center">
            <Col lg={10}>
              <div className="login-page-outer">
                <div className="login-form-outer">
                  <div className="section-title text-center">
                    {/* <img src={logo} alt="Browncon Investing" width="240" className="mb-5" /> */}

                    <h2>
                      {/* Sign Up To<span> Browncon Investing</span> */}
                      Invest with us
                    </h2>
                  </div>
                </div>
                <form className="contact-form" onSubmit={handleSubmit}>
                  <Row>
                    <Col xl={6} lg={6}>
                      <FormGroup>
                        <Input
                          id="lastName"
                          {...text(_v.lastName)}
                          required
                          placeholder="Enter Your Surname"
                          label="Last Name"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={6} lg={6}>
                      <FormGroup>
                        <Input
                          id="firstName"
                          {...text(_v.firstName)}
                          required
                          placeholder="Enter Your First Name"
                          label="First Name"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12}>
                      <FormGroup>
                        <Input
                          id="InputAmount"
                          required
                          {...email(_v.email)}
                          placeholder="Enter Your E-mail Address"
                          label="E-mail"
                          // type="email"
                        />
                      </FormGroup>
                    </Col>
                    {/* <Col xl={6} lg={6}>
                      <FormGroup>
                        <Input
                          id="password"
                          {...password(_v.password)}
                          required
                          placeholder="Enter Your Password"
                          label="Password"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={6} lg={6}>
                      <FormGroup>
                        <Input
                          id="confirmPassword"
                          {...password(_v.confirmPassword)}
                          required
                          placeholder="Re-type Password"
                          label="Re-type Password"
                        />
                      </FormGroup>
                    </Col> */}
                    <Col xl={6} lg={6}>
                      <FormGroup>
                        <Input
                          id="phone"
                          {...text(_v.phone)}
                          required
                          placeholder="E.g 08012345678"
                          label="Phone Number"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={6} lg={6}>
                      <FormGroup>
                        {/* <label>Date of Birth <span className="requred">*</span></label> */}

                        <Input
                          // type="date"
                          name="date"
                          {...date(_v.dateOfBirth)}
                          id="dateOfBirth"
                          placeholder="Date of Birth"
                          label="Date of Birth"
                          required
                          pattern="\d{2}-\d{2}-\d{4}"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={6} lg={6}>
                      <FormGroup>
                        <label>
                          Gender <span className="requred">*</span>
                        </label>

                        <Radio id="gender1" name="gender" label="Male" {...radio(_v.gender, 'Male')} />
                        <Radio id="gender2" name="gender" label="Female" {...radio(_v.gender, 'Female')} />
                        <Radio id="gender3" name="gender" label="Other" {...radio(_v.gender, 'Other')} />
                      </FormGroup>
                    </Col>
                    {/* <Col xl={12} lg={12}>
                    <FormGroup className="mb-0 checkbox">
                      <CheckBox id="gridCheck1" label="Keep me loged in" />
                    </FormGroup>
                  </Col> */}
                    <Col xl={12} lg={12}>
                      <Row className="d-flex">
                        <Col className="text-center" xl={12} lg={12}>
                          {loading ? (
                            <PreLoader />
                          ) : (
                            <PillButton className="login-button" label="Subscribe" type="submit" />
                          )}
                        </Col>
                        <Col xl={12} lg={12} className="text-center">
                          <Link to={routes.login} className="forgetting-password">
                            Already have an account? Login
                          </Link>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </div>
        </Container>
      </div>
    </Layout>
  );
}

export default Register;
